import { createContext } from '@berlin-front/common/composables/context';
import { UnwrapRef } from '@vue/composition-api';

// 各月の支払い
type SplitAmount = {
  // 請求月
  billingMonth: string;
  // 金額
  amount: number;
};

export type SplitPaymentContextType = {
  useSplitPayment: () => UnwrapRef<{
    // 商品合計金額
    itemTotalAmount: number;

    // １回あたりの支払い金額
    splitAmount: number;
    // 支払い回数
    splitTimes: number;
    // 各月の支払い金額
    amounts: SplitAmount[];
    // 分割払いの注意書き
    splitMessages: string[];

    // ユーザ名（フッターにユーザ名と「ログアウト」ボタンを表示する）
    memberName: string;
    // 「ご注文を確定」押下時のアクション
    onSubmit: () => void;
    // 「戻る」押下時のアクション
    goBack: () => void;
  }>;
};

export const SplitPaymentContext = createContext<SplitPaymentContextType>({} as SplitPaymentContextType);
